import { GetProvisionRequestOutput } from './provision-request-api.types';
import { DateTime } from 'luxon';

export class ProvisionRequest {
  constructor(public getProvisionRequestOutput: GetProvisionRequestOutput) {}

  static fromResultArray(
    provisionRequestOutput: GetProvisionRequestOutput[],
  ): ProvisionRequest[] {
    return provisionRequestOutput.map(
      (requestOutput) => new ProvisionRequest(requestOutput),
    );
  }

  get id() {
    return this.getProvisionRequestOutput.id;
  }

  get bezeichnung() {
    return this.getProvisionRequestOutput.bezeichnung;
  }

  get datum() {
    return this.getProvisionRequestOutput.datum;
  }

  get datumVon() {
    return this.getProvisionRequestOutput.datum_von;
  }

  get datumBis() {
    return this.getProvisionRequestOutput.datum_bis;
  }

  get beendetAm() {
    return this.getProvisionRequestOutput.beendet_am;
  }

  get moduleId() {
    return this.getProvisionRequestOutput.modulId;
  }

  get kleidungsart() {
    return this.getProvisionRequestOutput.kleidungsart;
  }

  get spindart() {
    switch (this.getProvisionRequestOutput.spindart) {
      case 1: {
        return 'Schmal (300mm)';
      }
      case 2: {
        return 'Breit (400mm)';
      }
      case 3: {
        return 'Doppelspind';
      }
      default: {
        return 'Unbekannt';
      }
    }
  }

  get rawLockerType() {
    return this.getProvisionRequestOutput.spindart;
  }

  get erstellerId() {
    return this.getProvisionRequestOutput.erstellerId;
  }

  get bemerkung() {
    return this.getProvisionRequestOutput.bemerkung;
  }

  get personen() {
    return this.getProvisionRequestOutput.personen;
  }

  get ersteller() {
    return this.getProvisionRequestOutput.ersteller;
  }

  get modul() {
    return this.getProvisionRequestOutput.modul;
  }

  get spindstandort() {
    switch (this.getProvisionRequestOutput.spindstandort) {
      case 1: {
        return 'B835';
      }
      case 2: {
        return 'B836';
      }
      case 3: {
        return 'B845';
      }
      default: {
        return null;
      }
    }
  }

  get rawSpindstandort() {
    return this.getProvisionRequestOutput.spindstandort;
  }

  get status() {
    const start = DateTime.fromISO(this.getProvisionRequestOutput.datum_von);
    const end = DateTime.fromISO(this.getProvisionRequestOutput.datum_bis);
    const closedOn = this.getProvisionRequestOutput.beendet_am;
    const now = DateTime.now();

    if (closedOn != null) {
      return 'Beendet';
    } else if (now < start) {
      return 'Ausstehend';
    } else if (now >= start && now <= end) {
      return 'Aktiv';
    } else {
      return 'Ausgelaufen';
    }
  }
}
